import { IContactPersonViewModel } from "./I4UViewModels";

export class ContactPersonUtils {
    /**
     * Check if given contact person can be considered empty (or not set).
     * @param cp
     */
    static isEmpty(cp: IContactPersonViewModel) {
        let arr = [cp.FirstName, cp.LastName, cp.Pin, cp.Phone, cp.Email];
        if (cp.Address != null) {
            arr.push(cp.Address.Street, cp.Address.Zip, cp.Address.Place);
        }
        for (let i = 0; i < arr.length; ++i) {
            if (arr[i])
                return false;
        }
        return true;
    }
}